import ViewModelCore from "./ViewModel";

export default class ChecklistAmostraLoteViewModel extends ViewModelCore{
    constructor () {
        super();
        this.ClienteId = undefined;
        this.RepresentanteId = undefined;
        this.UnidadeId = undefined;
        this.CodigoPedido = undefined;
        this.ProdutoIndustrializacaoComercializacao = undefined;
        this.Consumo = undefined;
        this.DataConsumo = undefined;
        this.OutrosCheck = undefined;
        this.CheckListAmostraId = undefined;
        this.PedidoId = undefined;
        this.UsuarioId = undefined;
        this.ConcorrenteId = undefined;
        this.UnidadeId = undefined;
        this.NumeroDaSolicitacao = undefined;
        this.CodigoPedido = undefined;
        this.Nome = undefined;
        this.NomeEmpresa = undefined;
        this.Homologacao = undefined;
        this.AprovacaoPadraoCor = undefined;
        this.Colecao = undefined;
        this.AprovacaoEmMaquinaCliente = undefined;
        this.AprovacaoEmMateriaPrima = undefined;
        this.NecessidadeTecnica = undefined;
        this.Exportacao = undefined;
        this.ProdutoCustoAprovado = undefined;
        this.ClienteAceitaMaterialDiferenteDaAmostra = undefined;
        this.ProdutoPossuiArquivoEletronico = undefined;
        this.CartelaDeCorEspecifica = undefined;
        this.ProdutoFeitoPorConcorrente = undefined;
        this.Reprovacao = undefined;
        this.MaterialReprovadoEmAnexo = undefined;
        this.IndustrializacaoComercializacao = undefined;
        this.ProdutoIndustrializacaoComercializacao = undefined;
        this.NomeConcorrente = undefined;
        this.NomeRepresentante = undefined;
        this.Outros = undefined;
        this.DataConsumo = undefined;
        this.DataDigitacao = undefined;
        this.DescricaoConsumo = undefined;
        this.MotivoReprovacao = undefined;
        this.Observacoes = undefined;
        this.HoraDigitacao = undefined;
        this.EmpresaCliente = undefined;
        this.Sincronismo = undefined;
        this.CodigoCliente = undefined;
        this.RazaoSocial = undefined;
        this.CodigoConcorrente = undefined;
        this.CodigoExterno = undefined;
        this.NumeroFormulario = undefined;
    }
}